import { RevealOnView } from "@/components/Reveal";
import { AXIOM } from "@/constants/testIds";

const TEAM = [
  {
    key: "karthik",
    name: "Karthik Pillai",
    role: "Deputy Manager, R&D",
    focus: "Execution & Technology",
    bio: "8+ years across FEA, CFD, experimentation, validation and product development.",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_engineer-axiom/artifacts/1y9js7qb_1.1.1%20Product%20-%20Wall%20Art%20-%20Artwork%20%2823%29%20%281%29.webp",
  },
  {
    key: "mohith",
    name: "Mohith Nair",
    role: "Senior Partner - Supply Chain",
    focus: "Operations & Strategy",
    bio: "10+ years in management and technology consulting across manufacturing supply chains.",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_engineer-axiom/artifacts/c79cbw3i_1.1.1%20Product%20-%20Wall%20Art%20-%20Artwork%20%2824%29%20%281%29.webp",
  },
  {
    key: "rajat",
    name: "Rajat Singh",
    role: "Sr. Mechanical Product Design",
    focus: "Product & Growth",
    bio: "8+ years taking mechanical products from concept to production at scale.",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_engineer-axiom/artifacts/yki80aqc_1.1.1%20Product%20-%20Wall%20Art%20-%20Artwork%20%2825%29%20%281%29.webp",
  },
];

export default function Team() {
  return (
    <section id="team" data-testid={AXIOM.team.root} className="bg-bg py-24 md:py-32 border-t border-rule">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <RevealOnView>
          <div className="grid grid-cols-12 gap-6 items-end">
            <div className="col-span-12 md:col-span-7">
              <div className="eyebrow mb-4">The team · Mumbai, India</div>
              <h2
                className="font-display text-ink"
                style={{ fontSize: "clamp(30px, 4vw, 46px)", lineHeight: 1.05, letterSpacing: "-0.02em" }}
              >
                Small team. <span className="text-forge">Serious résumé.</span>
              </h2>
            </div>
            <div className="col-span-12 md:col-span-4 md:col-start-9">
              <p className="text-ink/70" style={{ fontSize: "16px", lineHeight: 1.6 }}>
                A hands-on founding team with deep R&D leadership across simulation,
                product design and manufacturing supply-chain.
              </p>
            </div>
          </div>
        </RevealOnView>
        <div className="rule mt-10" />
        <div className="grid grid-cols-1 md:grid-cols-3">
          {TEAM.map((m, i) => (
            <RevealOnView key={m.key} delay={i * 0.06}>
              <div className={`p-8 md:p-10 border-b border-rule ${i < TEAM.length - 1 ? "md:border-r md:border-rule" : ""}`}
                   data-testid={AXIOM.team.member(m.key)}>
                <div className="flex items-baseline justify-between">
                  <div className="font-mono text-[11px] tracking-[0.14em] text-smoke uppercase">M/{String(i + 1).padStart(2, "0")}</div>
                  <div className="font-mono text-[11px] tracking-[0.14em] text-forge uppercase">{m.focus}</div>
                </div>
                <div className="mt-8 aspect-[4/5] bg-panel border border-rule flex items-end p-6 relative overflow-hidden">
                  {m.photo ? (
                    <>
                      <img
                        src={m.photo}
                        alt={m.name}
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-ink/45 via-transparent to-transparent" />
                      <div className="relative">
                        <div className="font-mono text-[10px] tracking-[0.14em] uppercase text-white">Founder</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="absolute inset-0 blueprint-grid opacity-50" />
                      <div
                        className="absolute top-6 left-6 font-display text-ink/15 select-none"
                        style={{ fontSize: "120px", lineHeight: 1, letterSpacing: "-0.03em" }}
                      >
                        {m.name.split(" ").map(w => w[0]).join("")}
                      </div>
                      <div className="relative">
                        <div className="font-mono text-[10px] tracking-[0.14em] uppercase text-smoke">Founder</div>
                      </div>
                    </>
                  )}
                </div>
                <h3
                  className="font-display text-ink mt-6"
                  style={{ fontSize: "26px", lineHeight: 1.1, letterSpacing: "-0.02em" }}
                >
                  {m.name}
                </h3>
                <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-forge mt-2">{m.role}</div>
                <p className="text-ink/75 mt-3 max-w-[40ch]" style={{ fontSize: "14px", lineHeight: 1.6 }}>
                  {m.bio}
                </p>
              </div>
            </RevealOnView>
          ))}
        </div>
      </div>
    </section>
  );
}
